import React, { useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const percentagePlugin = {
  id: "percentagePlugin",
  afterDatasetsDraw(chart, args, pluginOptions) {
    const { ctx, data } = chart;
    ctx.save();

    data.datasets.forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex);

      if (!meta.hidden && !dataset.hidden) {
        meta.data.forEach((datapoint, index) => {
          const value = dataset.data[index];
          const total = dataset.data.reduce((a, b) => a + b, 0);
          const percentage =
            total > 0 ? Math.round((value / total) * 100) + "%" : "0%";

          if (value > 0) {
            ctx.font = "bold 12px sans-serif";
            ctx.fillStyle = dataset.backgroundColor || "#e88904";
            ctx.textAlign = "center";
            ctx.textBaseline = "bottom";
            ctx.fillText(percentage, datapoint.x, datapoint.y - 5);
          }
        });
      }
    });

    ctx.restore();
  },
};

const STLYBookingWindow = ({
  setCompDataFromChild,
  rowIndex,
  colIndex,
  api,
  para,
  setting,
  dbdData,
}) => {
  const [hiddenDatasets, setHiddenDatasets] = useState({
    thisYear: false,
    lastYear: false,
  });

  const toggleDataset = (datasetKey) => {
    setHiddenDatasets((prev) => ({
      ...prev,
      [datasetKey]: !prev[datasetKey],
    }));
  };

  const dataObj = dbdData && dbdData.length > 0 ? dbdData[0] : {};

  const labels = [
    "0d",
    "1d",
    "2-7d",
    "8-15d",
    "16-30d",
    "31-60d",
    "61-90d",
    "91d+",
  ];

  const thisYearData = [
    dataObj.BW0_RMS || 0,
    dataObj.BW1_RMS || 0,
    dataObj.BW2TO7_RMS || 0,
    dataObj.BW8TO15_RMS || 0,
    dataObj.BW16TO30_RMS || 0,
    dataObj.BW31TO60_RMS || 0,
    dataObj.BW61TO90_RMS || 0,
    dataObj.BW91TOUP_RMS || 0,
  ];

  const lastYearData = [
    dataObj.BW0_LYRMS || 0,
    dataObj.BW1_LYRMS || 0,
    dataObj.BW2TO7_LYRMS || 0,
    dataObj.BW8TO15_LYRMS || 0,
    dataObj.BW16TO30_LYRMS || 0,
    dataObj.BW31TO60_LYRMS || 0,
    dataObj.BW61TO90_LYRMS || 0,
    dataObj.BW91TOUP_LYRMS || 0,
  ];

  const chartData = {
    labels,
    datasets: [
      {
        label: "CY",
        data: thisYearData,
        backgroundColor: "#e88904", // Orange from the image
        borderRadius: 2,
        barPercentage: 0.8,
        categoryPercentage: 0.7,
        hidden: hiddenDatasets.thisYear,
      },
      {
        label: "STLY",
        data: lastYearData,
        backgroundColor: "#4e5a6a", // Gray/blue from the image
        borderRadius: 2,
        barPercentage: 0.8,
        categoryPercentage: 0.7,
        hidden: hiddenDatasets.lastYear,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 25,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        mode: "index",
        intersect: false,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        titleColor: "#0f172a",
        bodyColor: "#475569",
        borderColor: "#e2e8f0",
        borderWidth: 1,
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          color: "#64748b",
          font: {
            family: "monospace",
            size: 12,
          },
        },
        border: {
          display: false,
        },
      },
      y: {
        display: false,
        grid: {
          display: false,
        },
      },
    },
    interaction: {
      mode: "index",
      intersect: false,
    },
  };

  return (
     <div className="widget-container" style={{ position: "relative" }}>
    <div className="stly-booking-container">
      <div className="stly-booking-header">
        <div>
          <h2 className="stly-booking-title">
            Booking Window — Next 30d Arrivals, CY vs STLY
          </h2>
          {/* <p className="stly-booking-subtitle">
            Who is booking me right now — planners or last-minute — and has that
            shifted?
          </p> */}
        </div>
        {/* <div className="stly-booking-link-wrapper">
          <span className="stly-booking-link-text">Booking Window</span>
          <span className="stly-booking-link-arrow">→</span>
        </div> */}
      </div>

      <div className="stly-chart-wrapper">
        <Bar data={chartData} options={options} plugins={[percentagePlugin]} />
      </div>

      <div className="stly-bottom-section">
        {/* <div className="stly-monospace-text">
          Window lengthening: 31-60d up 6pts YoY — planners with lower price
          sensitivity
        </div> */}
        <div className="stly-legend-wrapper">
          <div 
            className={`stly-legend-item ${hiddenDatasets.thisYear ? 'hidden' : ''}`}
            onClick={() => toggleDataset('thisYear')}
          >
            <div className="stly-legend-color-box this-year"></div>
            <span className="stly-legend-text">CY</span>
          </div>
          <div 
            className={`stly-legend-item ${hiddenDatasets.lastYear ? 'hidden' : ''}`}
            onClick={() => toggleDataset('lastYear')}
          >
            <div className="stly-legend-color-box last-year"></div>
            <span className="stly-legend-text">STLY</span>
          </div>
        </div>
      </div>
    </div>
     </div>
  );
};

export default STLYBookingWindow;
